import { Link } from "react-router-dom";
import React from "react";

const PreventiefOnderhoudSidebar = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("preventief-onderhoud")) {
    if (
      token.role === "admin" ||
      token.role === "manager" ||
      token.role === "medewerker"
    ) {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-tools"></i>
            </span>
            <span className="menu-text">Preventief Onderhoud</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            
            {/* Dashboard */}
            <div className="menu-item">
              <Link to="/preventief-onderhoud" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-tachometer-alt"></i>
                </span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </div>

            {/* Planning & Taken */}
            <div className="menu-item">
              <Link to="/preventief-onderhoud/planning" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-calendar-check"></i>
                </span>
                <span className="menu-text">Planning</span>
              </Link>
            </div>

            <div className="menu-item">
              <Link to="/preventief-onderhoud/taken" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-tasks"></i>
                </span>
                <span className="menu-text">Onderhoudstaken</span>
              </Link>
            </div>

            {/* Compliance */}
            <div className="menu-item">
              <Link to="/preventief-onderhoud/compliance" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-certificate"></i>
                </span>
                <span className="menu-text">Compliance</span>
              </Link>
            </div>

            {/* Voorraad */}
            <div className="menu-item">
              <Link to="/preventief-onderhoud/voorraad" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-boxes"></i>
                </span>
                <span className="menu-text">Voorraad</span>
              </Link>
            </div>

            {/* Rapportages */}
            <div className="menu-item">
              <Link to="/preventief-onderhoud/rapportages" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-chart-bar"></i>
                </span>
                <span className="menu-text">Rapportages</span>
              </Link>
            </div>

          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default PreventiefOnderhoudSidebar;